import api from '../api';

/**
 * Post manager generic data to an endpoint
 * @param {string} url - The URL to call
 * @param {any} data - The data to send
 * @returns {Promise<any>} The manager generic
 */
export const postManagerGeneric = async (url, data) => {
  const response = await api.post(url, data);
  return response.data;
};
